/**
 * Accordion Block JavaScript
 *
 * Handles accordion toggle functionality and accessibility.
 */

( function() {
	document.addEventListener( 'DOMContentLoaded', function() {
		const accordions = document.querySelectorAll( '.accordion' );

		accordions.forEach( ( accordion ) => {
			const buttons = accordion.querySelectorAll( '.accordion-item-button' );

			buttons.forEach( ( button ) => {
				button.addEventListener( 'click', function( event ) {
					event.preventDefault();

					const isExpanded = this.getAttribute( 'aria-expanded' ) === 'true';
					const panelId = this.getAttribute( 'aria-controls' );
					const panel = document.getElementById( panelId );

					if ( ! panel ) {
						return;
					}

					// Toggle the current item
					this.setAttribute( 'aria-expanded', ! isExpanded );
					panel.setAttribute( 'aria-hidden', isExpanded );

					// Optionally close other items (comment out to allow multiple open)
					// buttons.forEach( ( otherButton ) => {
					// if ( otherButton !== this ) {
					// otherButton.setAttribute( 'aria-expanded', 'false' );
					// const otherPanelId = otherButton.getAttribute( 'aria-controls' );
					// const otherPanel = document.getElementById( otherPanelId );
					// if ( otherPanel ) {
					// otherPanel.setAttribute( 'aria-hidden', 'true' );
					// }
					// }
					// } );
				} );
			} );
		} );
	} );
} )();
